export default "__VITE_ASSET__BQ5bOZWM__"